import React from 'react';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';

export const emptyDirector = () => ({
  _uid: crypto.randomUUID(),
  fullName: '',
  idNumber: '',
  email: '',
  phone: '',
  nationality: 'South African',
  residentialAddress: '',
});

const DirectorsStep = ({ formData, updateArr, addRow, removeRow }) => (
  <div className="space-y-4" data-testid="step-directors">
    <h3 className="text-xl font-semibold mb-2 text-emerald-800">Directors</h3>
    {formData.directors.map((d, i) => (
      <Card key={d._uid || `dir-${i}`}>
        <CardHeader className="bg-emerald-50">
          <div className="flex justify-between items-center">
            <CardTitle className="text-lg">Director {i + 1}</CardTitle>
            {formData.directors.length > 1 && (
              <Button
                variant="ghost"
                size="sm"
                onClick={() => removeRow('directors', i)}
                className="text-red-600"
                data-testid={`remove-director-${i}`}
              >
                Remove
              </Button>
            )}
          </div>
        </CardHeader>
        <CardContent className="pt-4 space-y-3">
          <div>
            <Label>Full Name *</Label>
            <Input
              value={d.fullName}
              data-testid={`director-name-${i}`}
              onChange={(e) => updateArr('directors', i, 'fullName', e.target.value)}
            />
          </div>
          <div className="grid md:grid-cols-2 gap-3">
            <div>
              <Label>ID / Passport Number *</Label>
              <Input
                value={d.idNumber}
                data-testid={`director-id-${i}`}
                onChange={(e) => updateArr('directors', i, 'idNumber', e.target.value)}
              />
            </div>
            <div>
              <Label>Nationality</Label>
              <select
                value={d.nationality}
                onChange={(e) => updateArr('directors', i, 'nationality', e.target.value)}
                className="w-full p-2 border border-gray-300 rounded-md"
              >
                <option>South African</option>
                <option>Other</option>
              </select>
            </div>
          </div>
          <div className="grid md:grid-cols-2 gap-3">
            <div>
              <Label>Email *</Label>
              <Input
                type="email"
                value={d.email}
                data-testid={`director-email-${i}`}
                onChange={(e) => updateArr('directors', i, 'email', e.target.value)}
              />
            </div>
            <div>
              <Label>Phone</Label>
              <Input
                value={d.phone}
                onChange={(e) => updateArr('directors', i, 'phone', e.target.value)}
              />
            </div>
          </div>
          <div>
            <Label>Residential Address</Label>
            <Input
              value={d.residentialAddress}
              onChange={(e) => updateArr('directors', i, 'residentialAddress', e.target.value)}
            />
          </div>
        </CardContent>
      </Card>
    ))}
    <Button
      onClick={() => addRow('directors', emptyDirector)}
      variant="outline"
      className="w-full border-dashed border-2 border-emerald-300 text-emerald-600 hover:bg-emerald-50"
      data-testid="add-director-btn"
    >
      + Add Another Director
    </Button>
  </div>
);

export default DirectorsStep;
